import { SET_ACTIVE_SEARCH_PRODUCT, CREATE_SEARCH_PRODUCTS } from '../../../../types/conversations/plugins'
import products from './products'

const initSearchState = {
  activeProduct: 'flight',
  products: {},
}

export default function search(state = initSearchState, action) {
  switch (action.type) {
    // Switch between products
    case SET_ACTIVE_SEARCH_PRODUCT: {
      const { activeProduct } = action
      return Object.assign({}, state, { activeProduct })
    }

    // Create the products state (one reducer per product)
    case CREATE_SEARCH_PRODUCTS: {
      if (Object.keys(state.products).length > 0) return state
      return Object.assign({}, state, {
        products: products(state.products, action),
      })
    }

    // Some product action
    default: {
      if (Object.keys(state.products).length <= 0) return state
      return Object.assign({}, state, {
        products: products(state.products, action),
      })
    }
  }
}
